module.exports = __webpack_public_path__ + "static/media/15_3.5ce04f56.png";